export default function clientMiddleware(client) {
    return ({/* dispatch, getState */}) => {
        return (next) => (action) => {
            const { promise, types, ...rest } = action;
            if (!promise) {
                return next(action);
            }

            const [REQUEST, SUCCESS, FAILURE] = types;
            next({...rest, type: REQUEST});
            return promise(client).then(
                (result) => next({...rest, result: result ? result.value : null, type: SUCCESS}),
                (error) => next({...rest, error: error.toString(), type: FAILURE})
            );
        };
    };
};


// WEBPACK FOOTER //
// ./app/redux/clientMiddleware.js